// extracted by mini-css-extract-plugin
module.exports = {"container":"Parallax_container__Ra_dn","content":"Parallax_content__kQTed"};